"use client";

import { useSelectedLayoutSegment } from "next/navigation";
import { MacroChartSkeleton, MacroIndexSkeleton } from "@/app/macro/MacroLoading";

export default function MacroRouteLoading() {
  const segment = useSelectedLayoutSegment();
  if (segment) return <MacroChartSkeleton />;
  return <MacroIndexSkeleton />;
}